/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeInventoryBotIdDto,
  ApiEnvelopeInventoryBulkChestConfigDto,
  ApiEnvelopeInventoryChestPageResponse,
  ApiEnvelopeInventoryChestSlotsDto,
  ApiEnvelopeInventoryChestSummaryDto,
  ApiEnvelopeInventoryChestsDeletedDto,
  ApiEnvelopeInventoryCraftOrderDto,
  ApiEnvelopeInventoryCraftOrderPlanDto,
  ApiEnvelopeInventoryCraftOrdersDto,
  ApiEnvelopeInventoryCraftPlanDto,
  ApiEnvelopeInventoryCraftRequestDto,
  ApiEnvelopeInventoryCustomItemsResponse,
  ApiEnvelopeInventoryEmptyDto,
  ApiEnvelopeInventoryExternalDemandDto,
  ApiEnvelopeInventoryItemsResponse,
  ApiEnvelopeInventoryMovePlanDto,
  ApiEnvelopeInventoryMoveRequestsResponse,
  ApiEnvelopeInventoryPlannedOrdersDto,
  ApiEnvelopeInventoryPricingResponse,
  ApiEnvelopeInventoryRecipeDetailDto,
  ApiEnvelopeInventoryRecipeDto,
  ApiEnvelopeInventoryReservationsDto,
  ApiEnvelopeInventoryResolveBatchDto,
  ApiEnvelopeInventoryResolveItemDto,
  ApiEnvelopeInventoryStockDto,
  ApiEnvelopeInventoryStorageBotAssignedDto,
  ApiEnvelopeInventoryStorageBotsResponse,
  ApiEnvelopeInventoryStorageCreatedDto,
  ApiEnvelopeInventoryStorageDto,
  ApiEnvelopeInventoryStorageItemsDto,
  ApiEnvelopeInventoryStorageListResponse,
  ApiEnvelopeInventoryTasksResponse,
  ApiEnvelopeInventoryTenantSettingsDto,
  InventoryAssignStorageBotRequest,
  InventoryBulkChestConfigRequest,
  InventoryChestPositionRequest,
  InventoryCreateCraftOrderRequest,
  InventoryCreateCraftRequest,
  InventoryCreateMoveRequest,
  InventoryCreateStorageRequest,
  InventoryCustomItemRequest,
  InventoryDeleteChestsRequest,
  InventoryGetChestsParams,
  InventoryGetMoveRequestsParams,
  InventoryGetRecipeDetailParams,
  InventoryMovePlanRequest,
  InventoryReadChestsRequest,
  InventoryResolveBatchRequest,
  InventoryRunLearnChestsRequest,
  InventoryRunScanRequest,
  InventoryRunStorageTaskRequest,
  InventorySaveStockRequest,
  InventorySetPricingBodyOne,
  InventorySetPricingBodyTwo,
  InventorySetStorageItemsBodyOne,
  InventorySetStorageItemsBodyTwo,
  InventoryUpdateChestConfigRequest,
  InventoryUpdateStorageRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type inventoryGetAllItemsResponse200 = {
  data: ApiEnvelopeInventoryItemsResponse
  status: 200
}

export type inventoryGetAllItemsResponseSuccess = (inventoryGetAllItemsResponse200) & {
  headers: Headers;
};
;

export type inventoryGetAllItemsResponse = (inventoryGetAllItemsResponseSuccess)

export const getInventoryGetAllItemsUrl = () => {




  return `/api/Inventory/items`
}

export const useInventoryGetAllItemsHook = (): ( options?: RequestInit) => Promise<inventoryGetAllItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetAllItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryGetRecipeResponse200 = {
  data: ApiEnvelopeInventoryRecipeDto
  status: 200
}

export type inventoryGetRecipeResponseSuccess = (inventoryGetRecipeResponse200) & {
  headers: Headers;
};
;

export type inventoryGetRecipeResponse = (inventoryGetRecipeResponseSuccess)

export const getInventoryGetRecipeUrl = (id: number,
    metadata: number,) => {




  return `/api/Inventory/recipe/${id}/${metadata}`
}

export const useInventoryGetRecipeHook = (): (id: number,
    metadata: number, options?: RequestInit) => Promise<inventoryGetRecipeResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: number,
    metadata: number, options?: RequestInit) => {

        return customFetcher(getInventoryGetRecipeUrl(id,metadata),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryGetStoragesResponse200 = {
  data: ApiEnvelopeInventoryStorageListResponse
  status: 200
}

export type inventoryGetStoragesResponseSuccess = (inventoryGetStoragesResponse200) & {
  headers: Headers;
};
;

export type inventoryGetStoragesResponse = (inventoryGetStoragesResponseSuccess)

export const getInventoryGetStoragesUrl = () => {




  return `/api/Inventory/storages`
}

export const useInventoryGetStoragesHook = (): ( options?: RequestInit) => Promise<inventoryGetStoragesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetStoragesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryCreateStorageResponse200 = {
  data: ApiEnvelopeInventoryStorageCreatedDto
  status: 200
}

export type inventoryCreateStorageResponseSuccess = (inventoryCreateStorageResponse200) & {
  headers: Headers;
};
;

export type inventoryCreateStorageResponse = (inventoryCreateStorageResponseSuccess)

export const getInventoryCreateStorageUrl = () => {




  return `/api/Inventory/storages`
}

export const useInventoryCreateStorageHook = (): (inventoryCreateStorageRequest?: InventoryCreateStorageRequest, options?: RequestInit) => Promise<inventoryCreateStorageResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryCreateStorageRequest?: InventoryCreateStorageRequest, options?: RequestInit) => {

        return customFetcher(getInventoryCreateStorageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCreateStorageRequest)
  }
);
      }
  }


export type inventoryGetStorageResponse200 = {
  data: ApiEnvelopeInventoryStorageDto
  status: 200
}

export type inventoryGetStorageResponse404 = {
  data: ApiEnvelopeInventoryStorageDto
  status: 404
}

export type inventoryGetStorageResponseSuccess = (inventoryGetStorageResponse200) & {
  headers: Headers;
};
export type inventoryGetStorageResponseError = (inventoryGetStorageResponse404) & {
  headers: Headers;
};

export type inventoryGetStorageResponse = (inventoryGetStorageResponseSuccess | inventoryGetStorageResponseError)

export const getInventoryGetStorageUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}`
}

export const useInventoryGetStorageHook = (): (id: string, options?: RequestInit) => Promise<inventoryGetStorageResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetStorageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryUpdateStorageResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUpdateStorageResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryUpdateStorageResponse403 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 403
}

export type inventoryUpdateStorageResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryUpdateStorageResponseSuccess = (inventoryUpdateStorageResponse200) & {
  headers: Headers;
};
export type inventoryUpdateStorageResponseError = (inventoryUpdateStorageResponse400 | inventoryUpdateStorageResponse403 | inventoryUpdateStorageResponse404) & {
  headers: Headers;
};

export type inventoryUpdateStorageResponse = (inventoryUpdateStorageResponseSuccess | inventoryUpdateStorageResponseError)

export const getInventoryUpdateStorageUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}`
}

export const useInventoryUpdateStorageHook = (): (id: string,
    inventoryUpdateStorageRequest?: InventoryUpdateStorageRequest, options?: RequestInit) => Promise<inventoryUpdateStorageResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryUpdateStorageRequest?: InventoryUpdateStorageRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUpdateStorageUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryUpdateStorageRequest)
  }
);
      }
  }


export type inventoryDeleteStorageResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryDeleteStorageResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryDeleteStorageResponse403 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 403
}

export type inventoryDeleteStorageResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryDeleteStorageResponseSuccess = (inventoryDeleteStorageResponse200) & {
  headers: Headers;
};
export type inventoryDeleteStorageResponseError = (inventoryDeleteStorageResponse400 | inventoryDeleteStorageResponse403 | inventoryDeleteStorageResponse404) & {
  headers: Headers;
};

export type inventoryDeleteStorageResponse = (inventoryDeleteStorageResponseSuccess | inventoryDeleteStorageResponseError)

export const getInventoryDeleteStorageUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}`
}

export const useInventoryDeleteStorageHook = (): (id: string, options?: RequestInit) => Promise<inventoryDeleteStorageResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryDeleteStorageUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryAddChestResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryAddChestResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryAddChestResponse403 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 403
}

export type inventoryAddChestResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryAddChestResponseSuccess = (inventoryAddChestResponse200) & {
  headers: Headers;
};
export type inventoryAddChestResponseError = (inventoryAddChestResponse400 | inventoryAddChestResponse403 | inventoryAddChestResponse404) & {
  headers: Headers;
};

export type inventoryAddChestResponse = (inventoryAddChestResponseSuccess | inventoryAddChestResponseError)

export const getInventoryAddChestUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/chests`
}

export const useInventoryAddChestHook = (): (id: string,
    inventoryChestPositionRequest?: InventoryChestPositionRequest, options?: RequestInit) => Promise<inventoryAddChestResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryChestPositionRequest?: InventoryChestPositionRequest, options?: RequestInit) => {

        return customFetcher(getInventoryAddChestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryChestPositionRequest)
  }
);
      }
  }


export type inventoryDeleteAllChestsResponse200 = {
  data: ApiEnvelopeInventoryChestsDeletedDto
  status: 200
}

export type inventoryDeleteAllChestsResponse403 = {
  data: ApiEnvelopeInventoryChestsDeletedDto
  status: 403
}

export type inventoryDeleteAllChestsResponse404 = {
  data: ApiEnvelopeInventoryChestsDeletedDto
  status: 404
}

export type inventoryDeleteAllChestsResponseSuccess = (inventoryDeleteAllChestsResponse200) & {
  headers: Headers;
};
export type inventoryDeleteAllChestsResponseError = (inventoryDeleteAllChestsResponse403 | inventoryDeleteAllChestsResponse404) & {
  headers: Headers;
};

export type inventoryDeleteAllChestsResponse = (inventoryDeleteAllChestsResponseSuccess | inventoryDeleteAllChestsResponseError)

export const getInventoryDeleteAllChestsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/chests`
}

export const useInventoryDeleteAllChestsHook = (): (id: string,
    inventoryDeleteChestsRequest?: InventoryDeleteChestsRequest, options?: RequestInit) => Promise<inventoryDeleteAllChestsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryDeleteChestsRequest?: InventoryDeleteChestsRequest, options?: RequestInit) => {

        return customFetcher(getInventoryDeleteAllChestsUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryDeleteChestsRequest)
  }
);
      }
  }


export type inventoryGetChestsResponse200 = {
  data: ApiEnvelopeInventoryChestPageResponse
  status: 200
}

export type inventoryGetChestsResponse403 = {
  data: ApiEnvelopeInventoryChestPageResponse
  status: 403
}

export type inventoryGetChestsResponse404 = {
  data: ApiEnvelopeInventoryChestPageResponse
  status: 404
}

export type inventoryGetChestsResponseSuccess = (inventoryGetChestsResponse200) & {
  headers: Headers;
};
export type inventoryGetChestsResponseError = (inventoryGetChestsResponse403 | inventoryGetChestsResponse404) & {
  headers: Headers;
};

export type inventoryGetChestsResponse = (inventoryGetChestsResponseSuccess | inventoryGetChestsResponseError)

export const getInventoryGetChestsUrl = (id: string,
    params?: InventoryGetChestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Inventory/storages/${id}/chests?${stringifiedParams}` : `/api/Inventory/storages/${id}/chests`
}

export const useInventoryGetChestsHook = (): (id: string,
    params?: InventoryGetChestsParams, options?: RequestInit) => Promise<inventoryGetChestsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: InventoryGetChestsParams, options?: RequestInit) => {

        return customFetcher(getInventoryGetChestsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryBulkUpdateChestConfigResponse200 = {
  data: ApiEnvelopeInventoryBulkChestConfigDto
  status: 200
}

export type inventoryBulkUpdateChestConfigResponse400 = {
  data: ApiEnvelopeInventoryBulkChestConfigDto
  status: 400
}

export type inventoryBulkUpdateChestConfigResponse403 = {
  data: ApiEnvelopeInventoryBulkChestConfigDto
  status: 403
}

export type inventoryBulkUpdateChestConfigResponse404 = {
  data: ApiEnvelopeInventoryBulkChestConfigDto
  status: 404
}

export type inventoryBulkUpdateChestConfigResponseSuccess = (inventoryBulkUpdateChestConfigResponse200) & {
  headers: Headers;
};
export type inventoryBulkUpdateChestConfigResponseError = (inventoryBulkUpdateChestConfigResponse400 | inventoryBulkUpdateChestConfigResponse403 | inventoryBulkUpdateChestConfigResponse404) & {
  headers: Headers;
};

export type inventoryBulkUpdateChestConfigResponse = (inventoryBulkUpdateChestConfigResponseSuccess | inventoryBulkUpdateChestConfigResponseError)

export const getInventoryBulkUpdateChestConfigUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/chests`
}

export const useInventoryBulkUpdateChestConfigHook = (): (id: string,
    inventoryBulkChestConfigRequest?: InventoryBulkChestConfigRequest, options?: RequestInit) => Promise<inventoryBulkUpdateChestConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryBulkChestConfigRequest?: InventoryBulkChestConfigRequest, options?: RequestInit) => {

        return customFetcher(getInventoryBulkUpdateChestConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryBulkChestConfigRequest)
  }
);
      }
  }


export type inventoryDeleteChestResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryDeleteChestResponse403 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 403
}

export type inventoryDeleteChestResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryDeleteChestResponseSuccess = (inventoryDeleteChestResponse200) & {
  headers: Headers;
};
export type inventoryDeleteChestResponseError = (inventoryDeleteChestResponse403 | inventoryDeleteChestResponse404) & {
  headers: Headers;
};

export type inventoryDeleteChestResponse = (inventoryDeleteChestResponseSuccess | inventoryDeleteChestResponseError)

export const getInventoryDeleteChestUrl = (id: string,
    chestId: string,) => {




  return `/api/Inventory/storages/${id}/chests/${chestId}`
}

export const useInventoryDeleteChestHook = (): (id: string,
    chestId: string, options?: RequestInit) => Promise<inventoryDeleteChestResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    chestId: string, options?: RequestInit) => {

        return customFetcher(getInventoryDeleteChestUrl(id,chestId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryUpdateChestConfigResponse200 = {
  data: ApiEnvelopeInventoryChestSummaryDto
  status: 200
}

export type inventoryUpdateChestConfigResponse400 = {
  data: ApiEnvelopeInventoryChestSummaryDto
  status: 400
}

export type inventoryUpdateChestConfigResponse403 = {
  data: ApiEnvelopeInventoryChestSummaryDto
  status: 403
}

export type inventoryUpdateChestConfigResponse404 = {
  data: ApiEnvelopeInventoryChestSummaryDto
  status: 404
}

export type inventoryUpdateChestConfigResponseSuccess = (inventoryUpdateChestConfigResponse200) & {
  headers: Headers;
};
export type inventoryUpdateChestConfigResponseError = (inventoryUpdateChestConfigResponse400 | inventoryUpdateChestConfigResponse403 | inventoryUpdateChestConfigResponse404) & {
  headers: Headers;
};

export type inventoryUpdateChestConfigResponse = (inventoryUpdateChestConfigResponseSuccess | inventoryUpdateChestConfigResponseError)

export const getInventoryUpdateChestConfigUrl = (id: string,
    chestId: string,) => {




  return `/api/Inventory/storages/${id}/chests/${chestId}`
}

export const useInventoryUpdateChestConfigHook = (): (id: string,
    chestId: string,
    inventoryUpdateChestConfigRequest?: InventoryUpdateChestConfigRequest, options?: RequestInit) => Promise<inventoryUpdateChestConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    chestId: string,
    inventoryUpdateChestConfigRequest?: InventoryUpdateChestConfigRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUpdateChestConfigUrl(id,chestId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryUpdateChestConfigRequest)
  }
);
      }
  }


export type inventoryRunReadChestsResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryRunReadChestsResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryRunReadChestsResponse403 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 403
}

export type inventoryRunReadChestsResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryRunReadChestsResponseSuccess = (inventoryRunReadChestsResponse200) & {
  headers: Headers;
};
export type inventoryRunReadChestsResponseError = (inventoryRunReadChestsResponse400 | inventoryRunReadChestsResponse403 | inventoryRunReadChestsResponse404) & {
  headers: Headers;
};

export type inventoryRunReadChestsResponse = (inventoryRunReadChestsResponseSuccess | inventoryRunReadChestsResponseError)

export const getInventoryRunReadChestsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/chests/read`
}

export const useInventoryRunReadChestsHook = (): (id: string,
    inventoryReadChestsRequest?: InventoryReadChestsRequest, options?: RequestInit) => Promise<inventoryRunReadChestsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryReadChestsRequest?: InventoryReadChestsRequest, options?: RequestInit) => {

        return customFetcher(getInventoryRunReadChestsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryReadChestsRequest)
  }
);
      }
  }


export type inventoryRunScanResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryRunScanResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryRunScanResponse403 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 403
}

export type inventoryRunScanResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryRunScanResponseSuccess = (inventoryRunScanResponse200) & {
  headers: Headers;
};
export type inventoryRunScanResponseError = (inventoryRunScanResponse400 | inventoryRunScanResponse403 | inventoryRunScanResponse404) & {
  headers: Headers;
};

export type inventoryRunScanResponse = (inventoryRunScanResponseSuccess | inventoryRunScanResponseError)

export const getInventoryRunScanUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/scan`
}

export const useInventoryRunScanHook = (): (id: string,
    inventoryRunScanRequest?: InventoryRunScanRequest, options?: RequestInit) => Promise<inventoryRunScanResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryRunScanRequest?: InventoryRunScanRequest, options?: RequestInit) => {

        return customFetcher(getInventoryRunScanUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryRunScanRequest)
  }
);
      }
  }


export type inventoryRunReadContentsResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryRunReadContentsResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryRunReadContentsResponse403 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 403
}

export type inventoryRunReadContentsResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryRunReadContentsResponseSuccess = (inventoryRunReadContentsResponse200) & {
  headers: Headers;
};
export type inventoryRunReadContentsResponseError = (inventoryRunReadContentsResponse400 | inventoryRunReadContentsResponse403 | inventoryRunReadContentsResponse404) & {
  headers: Headers;
};

export type inventoryRunReadContentsResponse = (inventoryRunReadContentsResponseSuccess | inventoryRunReadContentsResponseError)

export const getInventoryRunReadContentsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/read-contents`
}

export const useInventoryRunReadContentsHook = (): (id: string,
    inventoryRunStorageTaskRequest?: InventoryRunStorageTaskRequest, options?: RequestInit) => Promise<inventoryRunReadContentsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryRunStorageTaskRequest?: InventoryRunStorageTaskRequest, options?: RequestInit) => {

        return customFetcher(getInventoryRunReadContentsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryRunStorageTaskRequest)
  }
);
      }
  }


export type inventoryRunReadInfiniteSettingsResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryRunReadInfiniteSettingsResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryRunReadInfiniteSettingsResponse403 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 403
}

export type inventoryRunReadInfiniteSettingsResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryRunReadInfiniteSettingsResponseSuccess = (inventoryRunReadInfiniteSettingsResponse200) & {
  headers: Headers;
};
export type inventoryRunReadInfiniteSettingsResponseError = (inventoryRunReadInfiniteSettingsResponse400 | inventoryRunReadInfiniteSettingsResponse403 | inventoryRunReadInfiniteSettingsResponse404) & {
  headers: Headers;
};

export type inventoryRunReadInfiniteSettingsResponse = (inventoryRunReadInfiniteSettingsResponseSuccess | inventoryRunReadInfiniteSettingsResponseError)

export const getInventoryRunReadInfiniteSettingsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/read-infinite-settings`
}

export const useInventoryRunReadInfiniteSettingsHook = (): (id: string,
    inventoryRunStorageTaskRequest?: InventoryRunStorageTaskRequest, options?: RequestInit) => Promise<inventoryRunReadInfiniteSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryRunStorageTaskRequest?: InventoryRunStorageTaskRequest, options?: RequestInit) => {

        return customFetcher(getInventoryRunReadInfiniteSettingsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryRunStorageTaskRequest)
  }
);
      }
  }


export type inventoryRunSortResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryRunSortResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryRunSortResponse403 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 403
}

export type inventoryRunSortResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryRunSortResponseSuccess = (inventoryRunSortResponse200) & {
  headers: Headers;
};
export type inventoryRunSortResponseError = (inventoryRunSortResponse400 | inventoryRunSortResponse403 | inventoryRunSortResponse404) & {
  headers: Headers;
};

export type inventoryRunSortResponse = (inventoryRunSortResponseSuccess | inventoryRunSortResponseError)

export const getInventoryRunSortUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/sort`
}

export const useInventoryRunSortHook = (): (id: string,
    inventoryRunStorageTaskRequest?: InventoryRunStorageTaskRequest, options?: RequestInit) => Promise<inventoryRunSortResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryRunStorageTaskRequest?: InventoryRunStorageTaskRequest, options?: RequestInit) => {

        return customFetcher(getInventoryRunSortUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryRunStorageTaskRequest)
  }
);
      }
  }


export type inventoryRunLearnChestsResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryRunLearnChestsResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryRunLearnChestsResponse403 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 403
}

export type inventoryRunLearnChestsResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryRunLearnChestsResponseSuccess = (inventoryRunLearnChestsResponse200) & {
  headers: Headers;
};
export type inventoryRunLearnChestsResponseError = (inventoryRunLearnChestsResponse400 | inventoryRunLearnChestsResponse403 | inventoryRunLearnChestsResponse404) & {
  headers: Headers;
};

export type inventoryRunLearnChestsResponse = (inventoryRunLearnChestsResponseSuccess | inventoryRunLearnChestsResponseError)

export const getInventoryRunLearnChestsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/learn`
}

export const useInventoryRunLearnChestsHook = (): (id: string,
    inventoryRunLearnChestsRequest?: InventoryRunLearnChestsRequest, options?: RequestInit) => Promise<inventoryRunLearnChestsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryRunLearnChestsRequest?: InventoryRunLearnChestsRequest, options?: RequestInit) => {

        return customFetcher(getInventoryRunLearnChestsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryRunLearnChestsRequest)
  }
);
      }
  }


export type inventoryGetStorageBotsResponse200 = {
  data: ApiEnvelopeInventoryStorageBotsResponse
  status: 200
}

export type inventoryGetStorageBotsResponse403 = {
  data: ApiEnvelopeInventoryStorageBotsResponse
  status: 403
}

export type inventoryGetStorageBotsResponse404 = {
  data: ApiEnvelopeInventoryStorageBotsResponse
  status: 404
}

export type inventoryGetStorageBotsResponseSuccess = (inventoryGetStorageBotsResponse200) & {
  headers: Headers;
};
export type inventoryGetStorageBotsResponseError = (inventoryGetStorageBotsResponse403 | inventoryGetStorageBotsResponse404) & {
  headers: Headers;
};

export type inventoryGetStorageBotsResponse = (inventoryGetStorageBotsResponseSuccess | inventoryGetStorageBotsResponseError)

export const getInventoryGetStorageBotsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/bots`
}

export const useInventoryGetStorageBotsHook = (): (id: string, options?: RequestInit) => Promise<inventoryGetStorageBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetStorageBotsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryAssignStorageBotResponse200 = {
  data: ApiEnvelopeInventoryStorageBotAssignedDto
  status: 200
}

export type inventoryAssignStorageBotResponse400 = {
  data: ApiEnvelopeInventoryStorageBotAssignedDto
  status: 400
}

export type inventoryAssignStorageBotResponse403 = {
  data: ApiEnvelopeInventoryStorageBotAssignedDto
  status: 403
}

export type inventoryAssignStorageBotResponse404 = {
  data: ApiEnvelopeInventoryStorageBotAssignedDto
  status: 404
}

export type inventoryAssignStorageBotResponseSuccess = (inventoryAssignStorageBotResponse200) & {
  headers: Headers;
};
export type inventoryAssignStorageBotResponseError = (inventoryAssignStorageBotResponse400 | inventoryAssignStorageBotResponse403 | inventoryAssignStorageBotResponse404) & {
  headers: Headers;
};

export type inventoryAssignStorageBotResponse = (inventoryAssignStorageBotResponseSuccess | inventoryAssignStorageBotResponseError)

export const getInventoryAssignStorageBotUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/bots`
}

export const useInventoryAssignStorageBotHook = (): (id: string,
    inventoryAssignStorageBotRequest?: InventoryAssignStorageBotRequest, options?: RequestInit) => Promise<inventoryAssignStorageBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryAssignStorageBotRequest?: InventoryAssignStorageBotRequest, options?: RequestInit) => {

        return customFetcher(getInventoryAssignStorageBotUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryAssignStorageBotRequest)
  }
);
      }
  }


export type inventoryUnassignStorageBotResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUnassignStorageBotResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryUnassignStorageBotResponse403 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 403
}

export type inventoryUnassignStorageBotResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryUnassignStorageBotResponseSuccess = (inventoryUnassignStorageBotResponse200) & {
  headers: Headers;
};
export type inventoryUnassignStorageBotResponseError = (inventoryUnassignStorageBotResponse400 | inventoryUnassignStorageBotResponse403 | inventoryUnassignStorageBotResponse404) & {
  headers: Headers;
};

export type inventoryUnassignStorageBotResponse = (inventoryUnassignStorageBotResponseSuccess | inventoryUnassignStorageBotResponseError)

export const getInventoryUnassignStorageBotUrl = (id: string,
    botId: string,) => {




  return `/api/Inventory/storages/${id}/bots/${botId}`
}

export const useInventoryUnassignStorageBotHook = (): (id: string,
    botId: string, options?: RequestInit) => Promise<inventoryUnassignStorageBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    botId: string, options?: RequestInit) => {

        return customFetcher(getInventoryUnassignStorageBotUrl(id,botId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryGetChestSlotsResponse200 = {
  data: ApiEnvelopeInventoryChestSlotsDto
  status: 200
}

export type inventoryGetChestSlotsResponse403 = {
  data: ApiEnvelopeInventoryChestSlotsDto
  status: 403
}

export type inventoryGetChestSlotsResponse404 = {
  data: ApiEnvelopeInventoryChestSlotsDto
  status: 404
}

export type inventoryGetChestSlotsResponseSuccess = (inventoryGetChestSlotsResponse200) & {
  headers: Headers;
};
export type inventoryGetChestSlotsResponseError = (inventoryGetChestSlotsResponse403 | inventoryGetChestSlotsResponse404) & {
  headers: Headers;
};

export type inventoryGetChestSlotsResponse = (inventoryGetChestSlotsResponseSuccess | inventoryGetChestSlotsResponseError)

export const getInventoryGetChestSlotsUrl = (id: string,
    chestId: string,) => {




  return `/api/Inventory/storages/${id}/chests/${chestId}/slots`
}

export const useInventoryGetChestSlotsHook = (): (id: string,
    chestId: string, options?: RequestInit) => Promise<inventoryGetChestSlotsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    chestId: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetChestSlotsUrl(id,chestId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryGetStorageItemsResponse200 = {
  data: ApiEnvelopeInventoryStorageItemsDto
  status: 200
}

export type inventoryGetStorageItemsResponse403 = {
  data: ApiEnvelopeInventoryStorageItemsDto
  status: 403
}

export type inventoryGetStorageItemsResponse404 = {
  data: ApiEnvelopeInventoryStorageItemsDto
  status: 404
}

export type inventoryGetStorageItemsResponseSuccess = (inventoryGetStorageItemsResponse200) & {
  headers: Headers;
};
export type inventoryGetStorageItemsResponseError = (inventoryGetStorageItemsResponse403 | inventoryGetStorageItemsResponse404) & {
  headers: Headers;
};

export type inventoryGetStorageItemsResponse = (inventoryGetStorageItemsResponseSuccess | inventoryGetStorageItemsResponseError)

export const getInventoryGetStorageItemsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/items`
}

export const useInventoryGetStorageItemsHook = (): (id: string, options?: RequestInit) => Promise<inventoryGetStorageItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetStorageItemsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventorySetStorageItemsResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventorySetStorageItemsResponse403 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 403
}

export type inventorySetStorageItemsResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventorySetStorageItemsResponseSuccess = (inventorySetStorageItemsResponse200) & {
  headers: Headers;
};
export type inventorySetStorageItemsResponseError = (inventorySetStorageItemsResponse403 | inventorySetStorageItemsResponse404) & {
  headers: Headers;
};

export type inventorySetStorageItemsResponse = (inventorySetStorageItemsResponseSuccess | inventorySetStorageItemsResponseError)

export const getInventorySetStorageItemsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/items`
}

export const useInventorySetStorageItemsHook = (): (id: string,
    inventorySetStorageItemsBody?: InventorySetStorageItemsBodyOne | InventorySetStorageItemsBodyTwo, options?: RequestInit) => Promise<inventorySetStorageItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventorySetStorageItemsBody?: InventorySetStorageItemsBodyOne | InventorySetStorageItemsBodyTwo, options?: RequestInit) => {

        return customFetcher(getInventorySetStorageItemsUrl(id),
  {
    ...options,
    method: 'PUT'
    ,
    body: JSON.stringify(inventorySetStorageItemsBody)
  }
);
      }
  }


export type inventoryGetAllStorageItemsResponse200 = {
  data: ApiEnvelopeInventoryStorageItemsDto
  status: 200
}

export type inventoryGetAllStorageItemsResponseSuccess = (inventoryGetAllStorageItemsResponse200) & {
  headers: Headers;
};
;

export type inventoryGetAllStorageItemsResponse = (inventoryGetAllStorageItemsResponseSuccess)

export const getInventoryGetAllStorageItemsUrl = () => {




  return `/api/Inventory/storages/all/items`
}

export const useInventoryGetAllStorageItemsHook = (): ( options?: RequestInit) => Promise<inventoryGetAllStorageItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetAllStorageItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryResolveItemResponse200 = {
  data: ApiEnvelopeInventoryResolveItemDto
  status: 200
}

export type inventoryResolveItemResponse400 = {
  data: ApiEnvelopeInventoryResolveItemDto
  status: 400
}

export type inventoryResolveItemResponse403 = {
  data: ApiEnvelopeInventoryResolveItemDto
  status: 403
}

export type inventoryResolveItemResponse404 = {
  data: ApiEnvelopeInventoryResolveItemDto
  status: 404
}

export type inventoryResolveItemResponseSuccess = (inventoryResolveItemResponse200) & {
  headers: Headers;
};
export type inventoryResolveItemResponseError = (inventoryResolveItemResponse400 | inventoryResolveItemResponse403 | inventoryResolveItemResponse404) & {
  headers: Headers;
};

export type inventoryResolveItemResponse = (inventoryResolveItemResponseSuccess | inventoryResolveItemResponseError)

export const getInventoryResolveItemUrl = (storageId: string,
    itemKey: string,) => {




  return `/api/Inventory/resolve/${storageId}/${itemKey}`
}

export const useInventoryResolveItemHook = (): (storageId: string,
    itemKey: string, options?: RequestInit) => Promise<inventoryResolveItemResponse> => {

      const customFetcher = useSfetchMutator();
      return (storageId: string,
    itemKey: string, options?: RequestInit) => {

        return customFetcher(getInventoryResolveItemUrl(storageId,itemKey),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryResolveBatchResponse200 = {
  data: ApiEnvelopeInventoryResolveBatchDto
  status: 200
}

export type inventoryResolveBatchResponse403 = {
  data: ApiEnvelopeInventoryResolveBatchDto
  status: 403
}

export type inventoryResolveBatchResponse404 = {
  data: ApiEnvelopeInventoryResolveBatchDto
  status: 404
}

export type inventoryResolveBatchResponseSuccess = (inventoryResolveBatchResponse200) & {
  headers: Headers;
};
export type inventoryResolveBatchResponseError = (inventoryResolveBatchResponse403 | inventoryResolveBatchResponse404) & {
  headers: Headers;
};

export type inventoryResolveBatchResponse = (inventoryResolveBatchResponseSuccess | inventoryResolveBatchResponseError)

export const getInventoryResolveBatchUrl = () => {




  return `/api/Inventory/resolve-batch`
}

export const useInventoryResolveBatchHook = (): (inventoryResolveBatchRequest?: InventoryResolveBatchRequest, options?: RequestInit) => Promise<inventoryResolveBatchResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryResolveBatchRequest?: InventoryResolveBatchRequest, options?: RequestInit) => {

        return customFetcher(getInventoryResolveBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryResolveBatchRequest)
  }
);
      }
  }


export type inventoryGetRecipeDetailResponse200 = {
  data: ApiEnvelopeInventoryRecipeDetailDto
  status: 200
}

export type inventoryGetRecipeDetailResponseSuccess = (inventoryGetRecipeDetailResponse200) & {
  headers: Headers;
};
;

export type inventoryGetRecipeDetailResponse = (inventoryGetRecipeDetailResponseSuccess)

export const getInventoryGetRecipeDetailUrl = (id: number,
    metadata: number,
    params?: InventoryGetRecipeDetailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Inventory/recipe-detail/${id}/${metadata}?${stringifiedParams}` : `/api/Inventory/recipe-detail/${id}/${metadata}`
}

export const useInventoryGetRecipeDetailHook = (): (id: number,
    metadata: number,
    params?: InventoryGetRecipeDetailParams, options?: RequestInit) => Promise<inventoryGetRecipeDetailResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: number,
    metadata: number,
    params?: InventoryGetRecipeDetailParams, options?: RequestInit) => {

        return customFetcher(getInventoryGetRecipeDetailUrl(id,metadata,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryGetPricingResponse200 = {
  data: ApiEnvelopeInventoryPricingResponse
  status: 200
}

export type inventoryGetPricingResponse400 = {
  data: ApiEnvelopeInventoryPricingResponse
  status: 400
}

export type inventoryGetPricingResponseSuccess = (inventoryGetPricingResponse200) & {
  headers: Headers;
};
export type inventoryGetPricingResponseError = (inventoryGetPricingResponse400) & {
  headers: Headers;
};

export type inventoryGetPricingResponse = (inventoryGetPricingResponseSuccess | inventoryGetPricingResponseError)

export const getInventoryGetPricingUrl = () => {




  return `/api/Inventory/pricing`
}

export const useInventoryGetPricingHook = (): ( options?: RequestInit) => Promise<inventoryGetPricingResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetPricingUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventorySetPricingResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventorySetPricingResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventorySetPricingResponseSuccess = (inventorySetPricingResponse200) & {
  headers: Headers;
};
export type inventorySetPricingResponseError = (inventorySetPricingResponse400) & {
  headers: Headers;
};

export type inventorySetPricingResponse = (inventorySetPricingResponseSuccess | inventorySetPricingResponseError)

export const getInventorySetPricingUrl = () => {




  return `/api/Inventory/pricing`
}

export const useInventorySetPricingHook = (): (inventorySetPricingBody?: InventorySetPricingBodyOne | InventorySetPricingBodyTwo, options?: RequestInit) => Promise<inventorySetPricingResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventorySetPricingBody?: InventorySetPricingBodyOne | InventorySetPricingBodyTwo, options?: RequestInit) => {

        return customFetcher(getInventorySetPricingUrl(),
  {
    ...options,
    method: 'PUT'
    ,
    body: JSON.stringify(inventorySetPricingBody)
  }
);
      }
  }


export type inventoryGetTenantSettingsResponse200 = {
  data: ApiEnvelopeInventoryTenantSettingsDto
  status: 200
}

export type inventoryGetTenantSettingsResponse400 = {
  data: ApiEnvelopeInventoryTenantSettingsDto
  status: 400
}

export type inventoryGetTenantSettingsResponseSuccess = (inventoryGetTenantSettingsResponse200) & {
  headers: Headers;
};
export type inventoryGetTenantSettingsResponseError = (inventoryGetTenantSettingsResponse400) & {
  headers: Headers;
};

export type inventoryGetTenantSettingsResponse = (inventoryGetTenantSettingsResponseSuccess | inventoryGetTenantSettingsResponseError)

export const getInventoryGetTenantSettingsUrl = () => {




  return `/api/Inventory/tenant-settings`
}

export const useInventoryGetTenantSettingsHook = (): ( options?: RequestInit) => Promise<inventoryGetTenantSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetTenantSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryPlanCraftResponse200 = {
  data: ApiEnvelopeInventoryCraftPlanDto
  status: 200
}

export type inventoryPlanCraftResponse400 = {
  data: ApiEnvelopeInventoryCraftPlanDto
  status: 400
}

export type inventoryPlanCraftResponse403 = {
  data: ApiEnvelopeInventoryCraftPlanDto
  status: 403
}

export type inventoryPlanCraftResponse404 = {
  data: ApiEnvelopeInventoryCraftPlanDto
  status: 404
}

export type inventoryPlanCraftResponseSuccess = (inventoryPlanCraftResponse200) & {
  headers: Headers;
};
export type inventoryPlanCraftResponseError = (inventoryPlanCraftResponse400 | inventoryPlanCraftResponse403 | inventoryPlanCraftResponse404) & {
  headers: Headers;
};

export type inventoryPlanCraftResponse = (inventoryPlanCraftResponseSuccess | inventoryPlanCraftResponseError)

export const getInventoryPlanCraftUrl = () => {




  return `/api/Inventory/craft/plan`
}

export const useInventoryPlanCraftHook = (): (inventoryCreateCraftRequest?: InventoryCreateCraftRequest, options?: RequestInit) => Promise<inventoryPlanCraftResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryCreateCraftRequest?: InventoryCreateCraftRequest, options?: RequestInit) => {

        return customFetcher(getInventoryPlanCraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCreateCraftRequest)
  }
);
      }
  }


export type inventoryCreateCraftRequestResponse200 = {
  data: ApiEnvelopeInventoryCraftRequestDto
  status: 200
}

export type inventoryCreateCraftRequestResponse400 = {
  data: ApiEnvelopeInventoryCraftRequestDto
  status: 400
}

export type inventoryCreateCraftRequestResponse403 = {
  data: ApiEnvelopeInventoryCraftRequestDto
  status: 403
}

export type inventoryCreateCraftRequestResponse404 = {
  data: ApiEnvelopeInventoryCraftRequestDto
  status: 404
}

export type inventoryCreateCraftRequestResponseSuccess = (inventoryCreateCraftRequestResponse200) & {
  headers: Headers;
};
export type inventoryCreateCraftRequestResponseError = (inventoryCreateCraftRequestResponse400 | inventoryCreateCraftRequestResponse403 | inventoryCreateCraftRequestResponse404) & {
  headers: Headers;
};

export type inventoryCreateCraftRequestResponse = (inventoryCreateCraftRequestResponseSuccess | inventoryCreateCraftRequestResponseError)

export const getInventoryCreateCraftRequestUrl = () => {




  return `/api/Inventory/crafts`
}

export const useInventoryCreateCraftRequestHook = (): (inventoryCreateCraftRequest?: InventoryCreateCraftRequest, options?: RequestInit) => Promise<inventoryCreateCraftRequestResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryCreateCraftRequest?: InventoryCreateCraftRequest, options?: RequestInit) => {

        return customFetcher(getInventoryCreateCraftRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCreateCraftRequest)
  }
);
      }
  }


export type inventoryCancelCraftRequestResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryCancelCraftRequestResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryCancelCraftRequestResponse409 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 409
}

export type inventoryCancelCraftRequestResponseSuccess = (inventoryCancelCraftRequestResponse200) & {
  headers: Headers;
};
export type inventoryCancelCraftRequestResponseError = (inventoryCancelCraftRequestResponse400 | inventoryCancelCraftRequestResponse409) & {
  headers: Headers;
};

export type inventoryCancelCraftRequestResponse = (inventoryCancelCraftRequestResponseSuccess | inventoryCancelCraftRequestResponseError)

export const getInventoryCancelCraftRequestUrl = (id: string,) => {




  return `/api/Inventory/crafts/${id}`
}

export const useInventoryCancelCraftRequestHook = (): (id: string, options?: RequestInit) => Promise<inventoryCancelCraftRequestResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryCancelCraftRequestUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryPlanCraftOrderResponse200 = {
  data: ApiEnvelopeInventoryCraftOrderPlanDto
  status: 200
}

export type inventoryPlanCraftOrderResponse400 = {
  data: ApiEnvelopeInventoryCraftOrderPlanDto
  status: 400
}

export type inventoryPlanCraftOrderResponse403 = {
  data: ApiEnvelopeInventoryCraftOrderPlanDto
  status: 403
}

export type inventoryPlanCraftOrderResponse404 = {
  data: ApiEnvelopeInventoryCraftOrderPlanDto
  status: 404
}

export type inventoryPlanCraftOrderResponseSuccess = (inventoryPlanCraftOrderResponse200) & {
  headers: Headers;
};
export type inventoryPlanCraftOrderResponseError = (inventoryPlanCraftOrderResponse400 | inventoryPlanCraftOrderResponse403 | inventoryPlanCraftOrderResponse404) & {
  headers: Headers;
};

export type inventoryPlanCraftOrderResponse = (inventoryPlanCraftOrderResponseSuccess | inventoryPlanCraftOrderResponseError)

export const getInventoryPlanCraftOrderUrl = () => {




  return `/api/Inventory/craft/orders/plan`
}

export const useInventoryPlanCraftOrderHook = (): (inventoryCreateCraftOrderRequest?: InventoryCreateCraftOrderRequest, options?: RequestInit) => Promise<inventoryPlanCraftOrderResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryCreateCraftOrderRequest?: InventoryCreateCraftOrderRequest, options?: RequestInit) => {

        return customFetcher(getInventoryPlanCraftOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCreateCraftOrderRequest)
  }
);
      }
  }


export type inventoryCreateCraftOrderResponse200 = {
  data: ApiEnvelopeInventoryCraftOrderDto
  status: 200
}

export type inventoryCreateCraftOrderResponse400 = {
  data: ApiEnvelopeInventoryCraftOrderDto
  status: 400
}

export type inventoryCreateCraftOrderResponse403 = {
  data: ApiEnvelopeInventoryCraftOrderDto
  status: 403
}

export type inventoryCreateCraftOrderResponse404 = {
  data: ApiEnvelopeInventoryCraftOrderDto
  status: 404
}

export type inventoryCreateCraftOrderResponseSuccess = (inventoryCreateCraftOrderResponse200) & {
  headers: Headers;
};
export type inventoryCreateCraftOrderResponseError = (inventoryCreateCraftOrderResponse400 | inventoryCreateCraftOrderResponse403 | inventoryCreateCraftOrderResponse404) & {
  headers: Headers;
};

export type inventoryCreateCraftOrderResponse = (inventoryCreateCraftOrderResponseSuccess | inventoryCreateCraftOrderResponseError)

export const getInventoryCreateCraftOrderUrl = () => {




  return `/api/Inventory/craft/orders`
}

export const useInventoryCreateCraftOrderHook = (): (inventoryCreateCraftOrderRequest?: InventoryCreateCraftOrderRequest, options?: RequestInit) => Promise<inventoryCreateCraftOrderResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryCreateCraftOrderRequest?: InventoryCreateCraftOrderRequest, options?: RequestInit) => {

        return customFetcher(getInventoryCreateCraftOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCreateCraftOrderRequest)
  }
);
      }
  }


export type inventoryGetCraftOrdersResponse200 = {
  data: ApiEnvelopeInventoryCraftOrdersDto
  status: 200
}

export type inventoryGetCraftOrdersResponseSuccess = (inventoryGetCraftOrdersResponse200) & {
  headers: Headers;
};
;

export type inventoryGetCraftOrdersResponse = (inventoryGetCraftOrdersResponseSuccess)

export const getInventoryGetCraftOrdersUrl = () => {




  return `/api/Inventory/craft/orders`
}

export const useInventoryGetCraftOrdersHook = (): ( options?: RequestInit) => Promise<inventoryGetCraftOrdersResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetCraftOrdersUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryCancelCraftOrderResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryCancelCraftOrderResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryCancelCraftOrderResponse409 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 409
}

export type inventoryCancelCraftOrderResponseSuccess = (inventoryCancelCraftOrderResponse200) & {
  headers: Headers;
};
export type inventoryCancelCraftOrderResponseError = (inventoryCancelCraftOrderResponse400 | inventoryCancelCraftOrderResponse409) & {
  headers: Headers;
};

export type inventoryCancelCraftOrderResponse = (inventoryCancelCraftOrderResponseSuccess | inventoryCancelCraftOrderResponseError)

export const getInventoryCancelCraftOrderUrl = (id: string,) => {




  return `/api/Inventory/craft/orders/${id}`
}

export const useInventoryCancelCraftOrderHook = (): (id: string, options?: RequestInit) => Promise<inventoryCancelCraftOrderResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryCancelCraftOrderUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryCancelCraftOrderLineResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryCancelCraftOrderLineResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryCancelCraftOrderLineResponse409 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 409
}

export type inventoryCancelCraftOrderLineResponseSuccess = (inventoryCancelCraftOrderLineResponse200) & {
  headers: Headers;
};
export type inventoryCancelCraftOrderLineResponseError = (inventoryCancelCraftOrderLineResponse400 | inventoryCancelCraftOrderLineResponse409) & {
  headers: Headers;
};

export type inventoryCancelCraftOrderLineResponse = (inventoryCancelCraftOrderLineResponseSuccess | inventoryCancelCraftOrderLineResponseError)

export const getInventoryCancelCraftOrderLineUrl = (orderId: string,
    lineId: string,) => {




  return `/api/Inventory/craft/orders/${orderId}/lines/${lineId}`
}

export const useInventoryCancelCraftOrderLineHook = (): (orderId: string,
    lineId: string, options?: RequestInit) => Promise<inventoryCancelCraftOrderLineResponse> => {

      const customFetcher = useSfetchMutator();
      return (orderId: string,
    lineId: string, options?: RequestInit) => {

        return customFetcher(getInventoryCancelCraftOrderLineUrl(orderId,lineId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryGetStockResponse200 = {
  data: ApiEnvelopeInventoryStockDto
  status: 200
}

export type inventoryGetStockResponse403 = {
  data: ApiEnvelopeInventoryStockDto
  status: 403
}

export type inventoryGetStockResponse404 = {
  data: ApiEnvelopeInventoryStockDto
  status: 404
}

export type inventoryGetStockResponseSuccess = (inventoryGetStockResponse200) & {
  headers: Headers;
};
export type inventoryGetStockResponseError = (inventoryGetStockResponse403 | inventoryGetStockResponse404) & {
  headers: Headers;
};

export type inventoryGetStockResponse = (inventoryGetStockResponseSuccess | inventoryGetStockResponseError)

export const getInventoryGetStockUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/stock`
}

export const useInventoryGetStockHook = (): (id: string, options?: RequestInit) => Promise<inventoryGetStockResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetStockUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventorySaveStockResponse200 = {
  data: ApiEnvelopeInventoryStockDto
  status: 200
}

export type inventorySaveStockResponse400 = {
  data: ApiEnvelopeInventoryStockDto
  status: 400
}

export type inventorySaveStockResponse403 = {
  data: ApiEnvelopeInventoryStockDto
  status: 403
}

export type inventorySaveStockResponse404 = {
  data: ApiEnvelopeInventoryStockDto
  status: 404
}

export type inventorySaveStockResponseSuccess = (inventorySaveStockResponse200) & {
  headers: Headers;
};
export type inventorySaveStockResponseError = (inventorySaveStockResponse400 | inventorySaveStockResponse403 | inventorySaveStockResponse404) & {
  headers: Headers;
};

export type inventorySaveStockResponse = (inventorySaveStockResponseSuccess | inventorySaveStockResponseError)

export const getInventorySaveStockUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/stock`
}

export const useInventorySaveStockHook = (): (id: string,
    inventorySaveStockRequest?: InventorySaveStockRequest, options?: RequestInit) => Promise<inventorySaveStockResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventorySaveStockRequest?: InventorySaveStockRequest, options?: RequestInit) => {

        return customFetcher(getInventorySaveStockUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventorySaveStockRequest)
  }
);
      }
  }


export type inventoryGetPlannedOrdersResponse200 = {
  data: ApiEnvelopeInventoryPlannedOrdersDto
  status: 200
}

export type inventoryGetPlannedOrdersResponse403 = {
  data: ApiEnvelopeInventoryPlannedOrdersDto
  status: 403
}

export type inventoryGetPlannedOrdersResponse404 = {
  data: ApiEnvelopeInventoryPlannedOrdersDto
  status: 404
}

export type inventoryGetPlannedOrdersResponseSuccess = (inventoryGetPlannedOrdersResponse200) & {
  headers: Headers;
};
export type inventoryGetPlannedOrdersResponseError = (inventoryGetPlannedOrdersResponse403 | inventoryGetPlannedOrdersResponse404) & {
  headers: Headers;
};

export type inventoryGetPlannedOrdersResponse = (inventoryGetPlannedOrdersResponseSuccess | inventoryGetPlannedOrdersResponseError)

export const getInventoryGetPlannedOrdersUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/stock/planned-orders`
}

export const useInventoryGetPlannedOrdersHook = (): (id: string, options?: RequestInit) => Promise<inventoryGetPlannedOrdersResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetPlannedOrdersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryGetExternalDemandResponse200 = {
  data: ApiEnvelopeInventoryExternalDemandDto
  status: 200
}

export type inventoryGetExternalDemandResponse403 = {
  data: ApiEnvelopeInventoryExternalDemandDto
  status: 403
}

export type inventoryGetExternalDemandResponse404 = {
  data: ApiEnvelopeInventoryExternalDemandDto
  status: 404
}

export type inventoryGetExternalDemandResponseSuccess = (inventoryGetExternalDemandResponse200) & {
  headers: Headers;
};
export type inventoryGetExternalDemandResponseError = (inventoryGetExternalDemandResponse403 | inventoryGetExternalDemandResponse404) & {
  headers: Headers;
};

export type inventoryGetExternalDemandResponse = (inventoryGetExternalDemandResponseSuccess | inventoryGetExternalDemandResponseError)

export const getInventoryGetExternalDemandUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/stock/external-demand`
}

export const useInventoryGetExternalDemandHook = (): (id: string, options?: RequestInit) => Promise<inventoryGetExternalDemandResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetExternalDemandUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryGetTasksResponse200 = {
  data: ApiEnvelopeInventoryTasksResponse
  status: 200
}

export type inventoryGetTasksResponseSuccess = (inventoryGetTasksResponse200) & {
  headers: Headers;
};
;

export type inventoryGetTasksResponse = (inventoryGetTasksResponseSuccess)

export const getInventoryGetTasksUrl = () => {




  return `/api/Inventory/tasks`
}

export const useInventoryGetTasksHook = (): ( options?: RequestInit) => Promise<inventoryGetTasksResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetTasksUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryGetReservationsResponse200 = {
  data: ApiEnvelopeInventoryReservationsDto
  status: 200
}

export type inventoryGetReservationsResponse403 = {
  data: ApiEnvelopeInventoryReservationsDto
  status: 403
}

export type inventoryGetReservationsResponse404 = {
  data: ApiEnvelopeInventoryReservationsDto
  status: 404
}

export type inventoryGetReservationsResponseSuccess = (inventoryGetReservationsResponse200) & {
  headers: Headers;
};
export type inventoryGetReservationsResponseError = (inventoryGetReservationsResponse403 | inventoryGetReservationsResponse404) & {
  headers: Headers;
};

export type inventoryGetReservationsResponse = (inventoryGetReservationsResponseSuccess | inventoryGetReservationsResponseError)

export const getInventoryGetReservationsUrl = (id: string,) => {




  return `/api/Inventory/storages/${id}/reservations`
}

export const useInventoryGetReservationsHook = (): (id: string, options?: RequestInit) => Promise<inventoryGetReservationsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryGetReservationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryCancelTaskResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryCancelTaskResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryCancelTaskResponseSuccess = (inventoryCancelTaskResponse200) & {
  headers: Headers;
};
export type inventoryCancelTaskResponseError = (inventoryCancelTaskResponse400) & {
  headers: Headers;
};

export type inventoryCancelTaskResponse = (inventoryCancelTaskResponseSuccess | inventoryCancelTaskResponseError)

export const getInventoryCancelTaskUrl = (taskId: string,) => {




  return `/api/Inventory/tasks/${taskId}`
}

export const useInventoryCancelTaskHook = (): (taskId: string, options?: RequestInit) => Promise<inventoryCancelTaskResponse> => {

      const customFetcher = useSfetchMutator();
      return (taskId: string, options?: RequestInit) => {

        return customFetcher(getInventoryCancelTaskUrl(taskId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryGetCustomItemsResponse200 = {
  data: ApiEnvelopeInventoryCustomItemsResponse
  status: 200
}

export type inventoryGetCustomItemsResponseSuccess = (inventoryGetCustomItemsResponse200) & {
  headers: Headers;
};
;

export type inventoryGetCustomItemsResponse = (inventoryGetCustomItemsResponseSuccess)

export const getInventoryGetCustomItemsUrl = () => {




  return `/api/Inventory/custom-items`
}

export const useInventoryGetCustomItemsHook = (): ( options?: RequestInit) => Promise<inventoryGetCustomItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryGetCustomItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryUpsertCustomItemResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUpsertCustomItemResponseSuccess = (inventoryUpsertCustomItemResponse200) & {
  headers: Headers;
};
;

export type inventoryUpsertCustomItemResponse = (inventoryUpsertCustomItemResponseSuccess)

export const getInventoryUpsertCustomItemUrl = () => {




  return `/api/Inventory/custom-items`
}

export const useInventoryUpsertCustomItemHook = (): (inventoryCustomItemRequest?: InventoryCustomItemRequest, options?: RequestInit) => Promise<inventoryUpsertCustomItemResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryCustomItemRequest?: InventoryCustomItemRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUpsertCustomItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCustomItemRequest)
  }
);
      }
  }


export type inventoryPlanMoveResponse200 = {
  data: ApiEnvelopeInventoryMovePlanDto
  status: 200
}

export type inventoryPlanMoveResponse400 = {
  data: ApiEnvelopeInventoryMovePlanDto
  status: 400
}

export type inventoryPlanMoveResponse403 = {
  data: ApiEnvelopeInventoryMovePlanDto
  status: 403
}

export type inventoryPlanMoveResponse404 = {
  data: ApiEnvelopeInventoryMovePlanDto
  status: 404
}

export type inventoryPlanMoveResponseSuccess = (inventoryPlanMoveResponse200) & {
  headers: Headers;
};
export type inventoryPlanMoveResponseError = (inventoryPlanMoveResponse400 | inventoryPlanMoveResponse403 | inventoryPlanMoveResponse404) & {
  headers: Headers;
};

export type inventoryPlanMoveResponse = (inventoryPlanMoveResponseSuccess | inventoryPlanMoveResponseError)

export const getInventoryPlanMoveUrl = () => {




  return `/api/Inventory/moves/plan`
}

export const useInventoryPlanMoveHook = (): (inventoryMovePlanRequest?: InventoryMovePlanRequest, options?: RequestInit) => Promise<inventoryPlanMoveResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryMovePlanRequest?: InventoryMovePlanRequest, options?: RequestInit) => {

        return customFetcher(getInventoryPlanMoveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryMovePlanRequest)
  }
);
      }
  }


export type inventoryCreateMoveRequestResponse200 = {
  data: ApiEnvelopeInventoryMoveRequestsResponse
  status: 200
}

export type inventoryCreateMoveRequestResponse400 = {
  data: ApiEnvelopeInventoryMoveRequestsResponse
  status: 400
}

export type inventoryCreateMoveRequestResponse403 = {
  data: ApiEnvelopeInventoryMoveRequestsResponse
  status: 403
}

export type inventoryCreateMoveRequestResponse404 = {
  data: ApiEnvelopeInventoryMoveRequestsResponse
  status: 404
}

export type inventoryCreateMoveRequestResponseSuccess = (inventoryCreateMoveRequestResponse200) & {
  headers: Headers;
};
export type inventoryCreateMoveRequestResponseError = (inventoryCreateMoveRequestResponse400 | inventoryCreateMoveRequestResponse403 | inventoryCreateMoveRequestResponse404) & {
  headers: Headers;
};

export type inventoryCreateMoveRequestResponse = (inventoryCreateMoveRequestResponseSuccess | inventoryCreateMoveRequestResponseError)

export const getInventoryCreateMoveRequestUrl = () => {




  return `/api/Inventory/moves`
}

export const useInventoryCreateMoveRequestHook = (): (inventoryCreateMoveRequest?: InventoryCreateMoveRequest, options?: RequestInit) => Promise<inventoryCreateMoveRequestResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryCreateMoveRequest?: InventoryCreateMoveRequest, options?: RequestInit) => {

        return customFetcher(getInventoryCreateMoveRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCreateMoveRequest)
  }
);
      }
  }


export type inventoryGetMoveRequestsResponse200 = {
  data: ApiEnvelopeInventoryMoveRequestsResponse
  status: 200
}

export type inventoryGetMoveRequestsResponseSuccess = (inventoryGetMoveRequestsResponse200) & {
  headers: Headers;
};
;

export type inventoryGetMoveRequestsResponse = (inventoryGetMoveRequestsResponseSuccess)

export const getInventoryGetMoveRequestsUrl = (params?: InventoryGetMoveRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Inventory/moves?${stringifiedParams}` : `/api/Inventory/moves`
}

export const useInventoryGetMoveRequestsHook = (): (params?: InventoryGetMoveRequestsParams, options?: RequestInit) => Promise<inventoryGetMoveRequestsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: InventoryGetMoveRequestsParams, options?: RequestInit) => {

        return customFetcher(getInventoryGetMoveRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryCancelMoveRequestResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryCancelMoveRequestResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryCancelMoveRequestResponse409 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 409
}

export type inventoryCancelMoveRequestResponseSuccess = (inventoryCancelMoveRequestResponse200) & {
  headers: Headers;
};
export type inventoryCancelMoveRequestResponseError = (inventoryCancelMoveRequestResponse400 | inventoryCancelMoveRequestResponse409) & {
  headers: Headers;
};

export type inventoryCancelMoveRequestResponse = (inventoryCancelMoveRequestResponseSuccess | inventoryCancelMoveRequestResponseError)

export const getInventoryCancelMoveRequestUrl = (id: string,) => {




  return `/api/Inventory/moves/${id}`
}

export const useInventoryCancelMoveRequestHook = (): (id: string, options?: RequestInit) => Promise<inventoryCancelMoveRequestResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryCancelMoveRequestUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


